export const inputsLength = {
  username: {
    min: 1,
    max: 50,
  },
  password: {
    min: 8,
    max: 64,
  },
  email: {
    min: 1,
  },
  otp: {
    min: 6,
  },
  confirmPassword: {
    min: 8,
    max: 64,
  },
} as const;

export const REQUIRED_ERROR = 'Oops! Required data is empty';
export const EMAIL_ERROR = "Email should contain '@' symbol and domain";

export const MIN_LENGTH = 8;
export const lowerCaseRegex = /[a-z]/;
export const upperCaseRegex = /[A-Z]/;
export const numberOrSymbolRegex = /\d|[!@#$%^&*(),.?":{}|<>]/;
export const latinAlphanumericRegex = /^[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]*$/;
export const otpRegex = /^\d+$/;
